import {
  SKIN_MANIFEST,
  DEFAULT_T_SKIN_ID,
  DEFAULT_CT_SKIN_ID,
  type SkinDefinition,
} from './skin-manifest';

export class SkinRegistry {
  /** Get skin definition by ID, or undefined if unknown. */
  get(skinId: number): SkinDefinition | undefined {
    return SKIN_MANIFEST.get(skinId);
  }

  /** Get all skins available for a team (includes 'both' skins). */
  getForTeam(team: 'T' | 'CT'): SkinDefinition[] {
    const results: SkinDefinition[] = [];
    for (const skin of SKIN_MANIFEST.values()) {
      if (skin.team === team || skin.team === 'both') {
        results.push(skin);
      }
    }
    return results;
  }

  /** Get the default fallback skin ID for a team. */
  getDefaultSkinId(team: 'T' | 'CT'): number {
    return team === 'T' ? DEFAULT_T_SKIN_ID : DEFAULT_CT_SKIN_ID;
  }

  /**
   * Resolve a skin ID -- returns the skin if valid for the team,
   * otherwise the team default.
   */
  resolve(skinId: number, team: 'T' | 'CT'): SkinDefinition {
    const skin = SKIN_MANIFEST.get(skinId);
    if (skin && (skin.team === team || skin.team === 'both')) {
      return skin;
    }
    // Guaranteed to exist since defaults are always in the manifest
    return SKIN_MANIFEST.get(this.getDefaultSkinId(team))!;
  }

  /**
   * Resolve a skin ID without team restriction (cosmetic use).
   * Returns the skin if it exists, otherwise Default T.
   */
  resolveAny(skinId: number): SkinDefinition {
    return SKIN_MANIFEST.get(skinId) ?? SKIN_MANIFEST.get(DEFAULT_T_SKIN_ID)!;
  }

  /** Get all skin definitions. */
  getAll(): SkinDefinition[] {
    return Array.from(SKIN_MANIFEST.values());
  }
}

export const skinRegistry = new SkinRegistry();
